import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";
import { addresses } from "./services";
import { Link } from "react-router-dom";
import Spinner from "../../base/features/micro/Spinner";
import { HiPlus } from "react-icons/hi";
import Empty from "../../base/features/blocks/Empty";
import { isSiteDomain } from "../../settings/domainManager";

class Addresses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addresses: null,
    };
  }
  componentDidMount() {
    this.get_addresses();
  }
  get_addresses() {
    addresses().then((items) => {
      items && this.setState({ addresses: items.results });
    });
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col-auto align-self-center px-0">
            <Link to={isSiteDomain ? "/" : "/profile"}>
              <FiChevronRight size="26" className="" />
            </Link>
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bolder mb-0">آدرس های شما</h1>
          </div>
        </header>
        <body style={{ marginTop: "60px", marginBottom: "80px" }}>
          {this.state.addresses ? (
            this.state.addresses.length === 0 ? (
              <Empty text={"آدرسی ثبت نشده است."} />
            ) : (
              this.state.addresses.map((address, a) => (
                <div className="row mx-0 p-4 border-bottom">
                  <div className="col-12 px-0 fw-bold fs-6 mb-4">
                    {address.address}
                  </div>
                  {address.phone && (
                    <div className="col-12 px-0 mb-4">
                      <img
                        src={require("./icons/phone.svg").default}
                        alt="phone"
                        width="22"
                      />
                      <span className="me-2">{address.phone}</span>
                    </div>
                  )}
                  <div className="col px-0">
                    <img
                      src={require("./icons/note.svg").default}
                      alt="note"
                      width="22"
                    />
                    <span className="me-2">{address.postcode}</span>
                  </div>

                  <div className="col-auto px-0">
                    <Link
                      className="color-main"
                      to={`/addresses/${address.uid}`}
                    >
                      ویرایش
                    </Link>
                  </div>
                </div>
              ))
            )
          ) : (
            <Spinner />
          )}
        </body>
        <div
          dir="ltr"
          className="position-fixed"
          style={{ bottom: "20px", left: "20px" }}
        >
          <Link to={`/map`}>
            <div
              className="rounded-circle row mx-0 nav-bottom-grad"
              style={{
                height: "65px",
                width: "65px",
              }}
            >
              <div className="col align-self-center text-center px-0">
                <HiPlus size="38" className="text-white" />
              </div>
            </div>
          </Link>
        </div>
      </div>
    );
  }
}

export default Addresses;
